import { HeaderSideImage, HeaderTextOverlay } from "./components";

export const Header = ({ className, title, description, img, back, variant }) => {
  switch (variant) {
    case "50/50":
      return <HeaderSideImage className={className} title={title} description={description} img={img?.url} back={back} />;
    
    case "Under Text":
    default:
      return <HeaderTextOverlay className={className} title={title} description={description} img={img?.url} back={back} />;
  }
};

export default Header;
